import { render } from "./UserAvatarStack.vue?vue&type=template&id=484e55a4&scoped=true"
import script from "./UserAvatarStack.vue?vue&type=script&lang=js"
export * from "./UserAvatarStack.vue?vue&type=script&lang=js"

import "./UserAvatarStack.vue?vue&type=style&index=0&id=484e55a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484e55a4"]])

export default __exports__